/**
 * Centralized localStorage keys for Walking & Nutrition Notebook
 * All keys use the 'gym_notebook_' prefix for consistency
 */

export const STORAGE_KEYS = {
  // Authentication
  AUTH_TOKEN: 'gym_notebook_auth_token',
  ADMIN_AUTHENTICATED: 'gym_notebook_admin_authenticated',
  
  // Training & Exercise
  ACTIVE_PLAN: 'gym_notebook_active_plan',
  TRAINING_HISTORY: 'gym_notebook_training_history',
  EXERCISE_HISTORY: 'gym_notebook_exercise_history',
  FAVORITES: 'gym_notebook_favorites',
  CUSTOM_EXERCISES: 'gym_notebook_custom_exercises',
  EXERCISE_VIDEOS: 'gym_notebook_exercise_videos',
  EXERCISE_CATALOG_CACHE: 'gym_notebook_exercise_catalog',
  EXERCISE_CATALOG_EXPIRY: 'gym_notebook_exercise_catalog_expiry',
  
  // Walking
  WALKING_SESSION_HISTORY: 'gym_notebook_walking_session_history',
  WALKING_DAILY_DATA: 'gym_notebook_walking_daily_data',
  WALKING_ROUTINES: 'gym_notebook_walking_routines',
  WALKING_STRIDE_LENGTH: 'gym_notebook_walking_stride_length',
  
  // Nutrition
  NUTRITION_ONBOARDING: 'gym_notebook_nutrition_onboarding',
  NUTRITION_GOALS: 'gym_notebook_nutrition_goals',
  CUSTOM_PRODUCTS: 'gym_notebook_custom_products',
  SAVED_BARCODES: 'gym_notebook_saved_barcodes',
  BURNED_CALORIES: 'gym_notebook_burned_calories',
  
  // Body Measurements
  BODY_MEASUREMENTS: 'gym_notebook_body_measurements_history',
  PROGRESS_PHOTOS: 'gym_notebook_progress_photos',
  BODYWEIGHT: 'gym_notebook_bodyweight',
  WAIST: 'gym_notebook_waist',
  WAIST_HISTORY: 'gym_notebook_waist_history',
  WAIST_UNIT: 'gym_notebook_waist_unit',
  WEIGHT_GOAL: 'gym_notebook_weight_goal',
  WEIGHT_GOAL_START: 'gym_notebook_weight_goal_start',
  
  // User Preferences (Persistent)
  PERSISTENT_AGE: 'gym_notebook_persistent_age',
  PERSISTENT_BODYWEIGHT: 'gym_notebook_persistent_bodyweight',
  PERSISTENT_GENDER: 'gym_notebook_persistent_gender',
  PERSISTENT_HEIGHT: 'gym_notebook_persistent_height',
  PERSISTENT_HEIGHT_UNIT: 'gym_notebook_persistent_height_unit',
  PERSISTENT_MEASUREMENT_UNIT: 'gym_notebook_persistent_measurement_unit',
  PERSISTENT_MEASUREMENTS: 'gym_notebook_persistent_measurements',
  PERSISTENT_WEIGHT_UNIT: 'gym_notebook_persistent_weight_unit',
  
  // App Settings
  THEME: 'gym_notebook_theme',
  BG_THEME: 'gym_notebook_bg_theme',
  FOCUS_MODE: 'gym_notebook_focus_mode',
  APP_VERSION: 'gym_notebook_app_version',
  LAST_BACKUP: 'gym_notebook_last_backup',
  HEARTRATE_MONITOR: 'gym_notebook_heartrate_monitor',
  
  // Menu Customization
  MENU_ORDER: 'gym_notebook_menu_order',
};

/**
 * Migration map for old keys to new keys
 * This helps migrate data from old localStorage keys to new ones
 */
export const LEGACY_KEY_MAP = {
  'auth_token': STORAGE_KEYS.AUTH_TOKEN,
  'admin_authenticated': STORAGE_KEYS.ADMIN_AUTHENTICATED,
  'bgTheme': STORAGE_KEYS.BG_THEME,
  'nutrition_onboarding_complete': STORAGE_KEYS.NUTRITION_ONBOARDING,
  'walking_session_history': STORAGE_KEYS.WALKING_SESSION_HISTORY,
  'walking_daily_data': STORAGE_KEYS.WALKING_DAILY_DATA,
  'walkingRoutines': STORAGE_KEYS.WALKING_ROUTINES,
  'walking_stride_length': STORAGE_KEYS.WALKING_STRIDE_LENGTH,
  'walking_nutrition_app_version': STORAGE_KEYS.APP_VERSION,
  'walking_nutrition_bodyweight': STORAGE_KEYS.BODYWEIGHT,
  'walking_nutrition_waist': STORAGE_KEYS.WAIST,
  'walking_nutrition_waist_history': STORAGE_KEYS.WAIST_HISTORY,
  'walking_nutrition_waist_unit': STORAGE_KEYS.WAIST_UNIT,
};

/**
 * Migrate old localStorage keys to new keys
 * This should be called once on app startup
 */
export const migrateStorageKeys = () => {
  let migrated = 0;
  
  Object.entries(LEGACY_KEY_MAP).forEach(([oldKey, newKey]) => {
    const oldValue = localStorage.getItem(oldKey);
    if (oldValue !== null && localStorage.getItem(newKey) === null) {
      // Only migrate if old value exists and new key is empty
      localStorage.setItem(newKey, oldValue);
      localStorage.removeItem(oldKey);
      migrated++;
      console.log(`Migrated localStorage: ${oldKey} -> ${newKey}`);
    }
  });
  
  if (migrated > 0) {
    console.log(`Storage migration complete: ${migrated} keys migrated`);
  }
  
  return migrated;
};

export default STORAGE_KEYS;
